import React from 'react'
import Navigation from './pageComponents/navbar'
import ContactForm from './pageComponents/contactform'
import Footer from './pageComponents/footer'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import girlBoss from '../assets/girlBoss.jpg';
import Dolls from '../assets/Dolls.jpg';
import table from '../assets/table.jpg';

function CraftFestival() {
  return (
    <>
        <Navigation />
        <Container>
          <Row style={{marginTop: '2rem'}}>
            <Col className="d-flex justify-content-center align-items-center" sm={12} md={12} lg={12} xl={12}>
              <h1>
                Craft Fair at the Crab Orchard Christian Mountain Games
              </h1>
            </Col>
          </Row>
          <Row style={{marginTop: '2rem'}}>
            <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
              <img src={girlBoss} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
            </Col>
            <Col sm={12} md={6} lg={6} xl={6}>
            <p style={{ lineHeight: '2.5' }}>
              Nestled among the energy and tradition of the Crab Orchard Christian Mountain Games, the craft fair offers a welcoming space to slow down, explore, and connect. As the sounds of competition and celebration echo through the grounds, visitors can stroll through rows of artisan booths filled with handmade goods, unique creations, and one-of-a-kind treasures. It’s the perfect place to take a break from the action while still soaking in the spirit of the Games.
            </p>
            </Col>
          </Row>
          <Row style={{marginTop: '2rem'}}>
            <Col sm={12} md={6} lg={6} xl={6}>
            <p style={{ lineHeight: '2.5' }}>
              From hand-carved woodwork and custom metal pieces to handcrafted jewelry, textiles, and artwork, the craft fair highlights the creativity and skill of local and regional artisans. Many vendors are happy to share the stories behind their work, making each purchase more personal and meaningful. Whether you’re searching for a gift, home décor, or something truly unique, you’ll find pieces that reflect both craftsmanship and heart.
            </p>
            </Col>
            <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
              <img src={Dolls} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
            </Col>
          </Row>
          <Row style={{marginTop: '2rem'}}>
            <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
              <img src={table} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50"/>
            </Col>
            <Col sm={12} md={6} lg={6} xl={6}>
            <p style={{ lineHeight: '2.5' }}>
              The craft fair is designed to be family-friendly and inviting, encouraging visitors of all ages to browse, ask questions, and enjoy the experience together. It complements the athletic feats and cultural traditions of the Mountain Games by celebrating creativity, community, and connection. Be sure to stop by, support talented makers, and take home a piece of the Crab Orchard experience with you.
            </p>
            </Col>
          </Row>
        </Container>
        <ContactForm />
        <Footer />
    </>
  )
}

export default CraftFestival